import { ColumnDef } from '@tanstack/react-table';
import { get, merge } from 'lodash';
import { format } from '../../../../../utils';
import { ContentAlignment, TableColumn } from '../..';
import { CellTypeStrategy } from '../models';
import { toNumber } from './utils';
import { NumberCellRenderer } from './NumberCellRenderer';

export class NumberCell<TData> implements CellTypeStrategy<TData> {
  public getDefaultColumnDef(col: TableColumn<TData>): Partial<ColumnDef<TData>> {
    return {
      accessorFn: (row: TData, index: number) => {
        const value = get(row, col.id);
        if (value == null) {
          return null;
        }
        const numberValue = toNumber(value);
        if (Number.isNaN(numberValue)) {
          return 'NaN';
        }
        const valueFormatEnabled = col.meta?.valueFormatter?.enabled;
        if (valueFormatEnabled) {
          const type = col.meta?.valueFormatter?.formatAs?.type ?? 'number.short';
          const options = merge(
            {},
            {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            },
            col.meta?.valueFormatter?.formatAs?.options,
          );
          return String(format(type, numberValue, options));
        }
        return String(numberValue);
      },
      cell: NumberCellRenderer,
      meta: {
        align: ContentAlignment.RIGHT,
      },
    };
  }
}
